<div class="prompt-modal-container display-flex flex-column">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content>
    <form [formGroup]="form" class="mb-20">
      <div class="display-flex flex-column grid-gap-16">
        <ng-container *ngIf="data.isMultiline; else singleLineInput">
          <app-input-area
            class="w-100"
            [label]="data.fieldName"
            [inputCss]="'hp-92'"
            [labelCss]="'body-small-bold nowrap'"
            [containerCss]="'fill body-small'"
            [formControl]="displayName"
            [attrPlaceholder]="data.fieldPlaceholder"
            [showValidationError]="isSubmitted"
            [displayCounter]="true"
            [maxCounter]="data.maxLength || null"></app-input-area>
        </ng-container>

        <ng-template #singleLineInput>
          <app-input
            [attrLabel]="data.fieldName"
            [contentCss]="'display-flex flex-column fill company-details-input body-small'"
            [formControl]="displayName"
            [attrPlaceholder]="data.fieldPlaceholder"
            [labelRequired]="data.isRequired !== false"
            [showValidationError]="isSubmitted"
            [maxCounter]="data.maxLength || null"
            (keydownEnterEvent)="save()"></app-input>
        </ng-template>
      </div>
    </form>
  </mat-dialog-content>
  <mat-dialog-actions class="justify-content-space-between">
    <button mat-stroked-button [color]="data.cancelButtonColor" (click)="cancel()">Cancel</button>
    <button mat-raised-button [color]="data.okButtonColor" (click)="save()">{{ data.okButtonText }}</button>
  </mat-dialog-actions>
</div>
